"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseGameController = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BaseGameController = exports.BaseGameController = /*#__PURE__*/function () {
  function BaseGameController() {
    _classCallCheck(this, BaseGameController);
  }
  return _createClass(BaseGameController, [{
    key: "newRound",
    value: function newRound() {
      return true;
    }
  }, {
    key: "spinEnd",
    value: function spinEnd(freeSpin) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "maxWin",
    value: function maxWin(coins) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "uiButtonPress",
    value: function uiButtonPress(buttonIdentifier) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "expandingSymbol",
    value: function expandingSymbol(command) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "expandingSymbolCollect",
    value: function expandingSymbolCollect(command) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "spinExpandingSymbolCollect",
    value: function spinExpandingSymbolCollect(command) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "featureCoins",
    value: function featureCoins(command, blitzsed) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onRoundEnd",
    value: function onRoundEnd(replay) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onRoundStart",
    value: function onRoundStart() {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "coinMultiplier",
    value: function coinMultiplier(f) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "winMultiplier",
    value: function winMultiplier(f) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "collect",
    value: function collect(f, currentCollection) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "collectReward",
    value: function collectReward(f) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "stop",
    value: function stop(reels, freeSpin, reSpin, quickStop) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "setReels",
    value: function setReels(f) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "quickStop",
    value: function quickStop() {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "gameReady",
    value: function gameReady() {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "spin",
    value: function spin(freeSpin, reconnectSpin) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "reSpinReel",
    value: function reSpinReel(index) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onFreeSpinStart",
    value: function onFreeSpinStart(triggerCount, reconnect, amount, command) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onFreeSpinEnd",
    value: function onFreeSpinEnd(triggerCount, reconnect) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onReSpinStart",
    value: function onReSpinStart(f) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onReSpinEnd",
    value: function onReSpinEnd() {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "showAllPayLines",
    value: function showAllPayLines() {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "showWinLine",
    value: function showWinLine(line, freeSpin) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "showWinLineInstant",
    value: function showWinLineInstant(line, freeSpin) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "winLinePresentationEnd",
    value: function winLinePresentationEnd(freespin) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "winLinePresentationStop",
    value: function winLinePresentationStop() {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "showBigWin",
    value: function showBigWin(coinsWon, level) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onIdle",
    value: function onIdle() {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "stopWinRepeat",
    value: function stopWinRepeat(freespin) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "AdditionalFreespins",
    value: function AdditionalFreespins(f) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onFeature",
    value: function onFeature(f, blitz) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "onFeatureEnd",
    value: function onFeatureEnd(f) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }, {
    key: "customCommand",
    value: function customCommand(f) {
      return new Promise(function (resolve, reject) {
        resolve();
      });
    }
  }]);
}();
//# sourceMappingURL=BaseGameController.js.map